export const GET_JAR_LIST="GET_JAR_LIST";
export const GET_JAR_LIST_SUCCESSFULL = "GET_JAR_LIST_SUCCESSFULL";
export const JAR_FAILED = "JAR_FAILED";
export const EDIT_JAR_DATA = "EDIT_JAR_DATA";
export const EDIT_JAR_DATA_SUCCESSFULLY = "EDIT_JAR_DATA_SUCCESSFULLY";
export const DELETE_JAR_DATA = "DELETE_JAR_DATA";
export const DELETE_JAR_DATA_SUCCESSFULLY = "DELETE_JAR_DATA_SUCCESSFULLY";
